import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import EmiCalculator from './EmiCalculator';

function Services() {
    useEffect(() => {
        document.querySelectorAll('.set-bg').forEach(el => {
            const bg = el.getAttribute('data-setbg');
            if (bg) {
                el.style.backgroundImage = `url('/${bg}')`;
            }
        });
    }, []);

    return (
        <>
            {/* <!-- Breadcrumb Section Begin --> */}
            <div className="breadcrumb-option set-bg" data-setbg="img/breadcrumb/brd.webp">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <div className="breadcrumb__text">
                                <h2>Our Loan & Financial Services</h2>
                                <div className="breadcrumb__links">
                                    <Link to="/">Home</Link>
                                    <span>Services</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Breadcrumb Section End --> */}

            {/* <!-- Services Section Begin --> */}
            <section className="services spad">
                <div className="container">
                    <div className="row">

                        {/* 01. Personal Loan */}
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="services__item">
                                <div className="services__item__img">
                                    <img src="img/services/ploan.webp" alt="Personal Loan" />
                                </div>
                                <div className="services__item__text">
                                    <h4><span>01.</span> Personal Loan</h4>
                                    <p>Quick funds for medical expenses, travel, education, weddings, or any personal need — with minimal documentation.</p>
                                    <Link to="/contact">Find Out More</Link>
                                </div>
                            </div>
                        </div>

                        {/* 02. Business Loan */}
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="services__item">
                                <div className="services__item__img">
                                    <img src="img/services/bloan.webp" alt="Business Loan" />
                                </div>
                                <div className="services__item__text">
                                    <h4><span>02.</span> Business Loan</h4>
                                    <p>Fuel your business growth with flexible funding options, easy repayment terms, and fast approval for all business types.</p>
                                    <Link to="/contact">Find Out More</Link>
                                </div>
                            </div>
                        </div>

                        {/* 03. Loan Against Property */}
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="services__item">
                                <div className="services__item__img">
                                    <img src="img/services/laproperty.webp" alt="Loan Against Property" />
                                </div>
                                <div className="services__item__text">
                                    <h4><span>03.</span> Loan Against Property</h4>
                                    <p>Unlock the value of your residential or commercial property to meet large financial requirements at low interest rates.</p>
                                    <Link to="/contact">Find Out More</Link>
                                </div>
                            </div>
                        </div>

                        {/* 04. Credit Card */}
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="services__item">
                                <div className="services__item__img">
                                    <img src="img/services/card.webp" alt="Credit Card" />
                                </div>
                                <div className="services__item__text">
                                    <h4><span>04.</span> Credit Card</h4>
                                    <p>Enjoy exclusive rewards, cashback offers, and flexible credit limits with our top credit card options from leading banks.</p>
                                    <Link to="/contact">Find Out More</Link>
                                </div>
                            </div>
                        </div>

                        {/* 05. Balance Transfer / Top-Up */}
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="services__item">
                                <div className="services__item__img">
                                    <img src="img/services/balance.webp" alt="Balance Transfer / Top-Up" />
                                </div>
                                <div className="services__item__text">
                                    <h4><span>05.</span> Balance Transfer / Top-Up</h4>
                                    <p>Transfer your existing loan to a lower interest rate and get additional top-up funds — save more on every EMI.</p>
                                    <Link to="/contact">Find Out More</Link>
                                </div>
                            </div>
                        </div>

                        {/* 06. Gold Loan */}
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="services__item">
                                <div className="services__item__img">
                                    <img src="img/services/gold.webp" alt="Gold Loan" />
                                </div>
                                <div className="services__item__text">
                                    <h4><span>06.</span> Gold Loan</h4>
                                    <p>Get instant funds against your gold jewellery with minimal documentation, quick processing, and same-day disbursal.</p>
                                    <Link to="/contact">Find Out More</Link>
                                </div>
                            </div>
                        </div>

                        {/* 07. Car Loan */}
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="services__item">
                                <div className="services__item__img">
                                    <img src="img/services/car.webp" alt="Car Loan" />
                                </div>
                                <div className="services__item__text">
                                    <h4><span>07.</span> Car Loan</h4>
                                    <p>Drive your dream car home today with affordable EMIs, competitive interest rates, and quick approval for new or used cars.</p>
                                    <Link to="/contact">Find Out More</Link>
                                </div>
                            </div>
                        </div>

                        {/* 08. Home Loan */}
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="services__item">
                                <div className="services__item__img">
                                    <img src="img/services/home.webp" alt="Home Loan" />
                                </div>
                                <div className="services__item__text">
                                    <h4><span>08.</span> Home Loan</h4>
                                    <p>Make your dream home a reality with our competitive home loan solutions — low rates, flexible tenure, and fast processing.</p>
                                    <Link to="/contact">Find Out More</Link>
                                </div>
                            </div>
                        </div>

                        {/* 09. Insurance */}
                        <div className="col-lg-4 col-md-4 col-sm-6">
                            <div className="services__item">
                                <div className="services__item__img">
                                    <img src="img/services/ins.webp" alt="Insurance" />
                                </div>
                                <div className="services__item__text">
                                    <h4><span>09.</span> Insurance</h4>
                                    <p>Protect your life, health, home, and assets with the right insurance coverage — tailored plans from trusted providers.</p>
                                    <Link to="/contact">Find Out More</Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <EmiCalculator />
            </section>
            {/* <!-- Services End --> */}
            
        </>
    );
}

export default Services;